import { createTheme } from '@mui/material/styles'

export const MuiTheme = createTheme({
  typography: {
    fontFamily: `"Montserrat", sans-serif`,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: `"Montserrat", sans-serif`,
        },
      },
    },
  },
})
